<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/retail/loreal_canada.png">
            L'Oréal Canada
        </client-card>
        <client-card src="img/clients-color/retail/couche_tard.png">
            Couche Tard
        </client-card>
        <client-card src="img/clients-color/retail/nedco.png">
            Nedco
        </client-card>
        <client-card src="img/clients-color/retail/decathlon-canada.png">
            Decathlon Canada
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-other-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Eye-In Client guest wifi|Client Eye-In wifi public et social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
